import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { OrderAdditionalInfo } from '../../components/widgets/Order';
import { OrderAdditionalInfoV1 } from '../../components/widgets/Order';
import { addManualTag, getTags } from '../../store/tags/actions';

const OrderAdditionalInfos = (props) => {
  const { isNewUI } = props;
  if (isNewUI) return <OrderAdditionalInfoV1 {...props} />;
  else return <OrderAdditionalInfo {...props} />;
};

const mapStateToProps = (state, ownProps) => {
  const { commentsState, tagsState, ordersState } = state;
  const { commentsList } = commentsState;
  const { tagsList } = tagsState;
  const { isNewUI } = ordersState;
  const {
    orderBasicInfo,
    orderId,
    cartId,
    getTransactionsDetails = () => {},
    openDominosPopup = () => {},
  } = ownProps;
  const comments =
    orderId &&
    commentsList &&
    commentsList[cartId] &&
    commentsList[cartId].length
      ? commentsList[cartId]
      : null;
  const tags =
    orderId && tagsList && tagsList[orderId] && tagsList[orderId].length
      ? tagsList[orderId]
      : null;

  return {
    isNewUI,
    orderBasicInfo,
    comments,
    tags,
    getTransactionsDetails,
    openDominosPopup,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addManualTag: (url, data, userId) =>
      dispatch(addManualTag(url, data, userId)),
    getTags: (data) => dispatch(getTags(data)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OrderAdditionalInfos),
);
